import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import { PlatformConfig, PlatformConfigUpdate } from '../../models/platform-config';
import baseQueryWithReauth from './base';

const platformConfigApi = createApi({
  reducerPath: 'platformConfigApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    updatePlatformConfig: build.mutation<PlatformConfig, PlatformConfigUpdate>({
      query: (body) => ({
        url: 'platform/config',
        method: 'PATCH',
        body,
      }),
      transformResponse: (response: Response<PlatformConfig>): PlatformConfig => {
        if (!response.data) {
          throw new Error('Missing platform config in response');
        }
        return response.data;
      },
    }),
  }),
});

export const { useUpdatePlatformConfigMutation } = platformConfigApi;
export { platformConfigApi };
